import React from 'react';
import { DeleteButton } from 'react-admin';

interface HumanDeleteButtonProps {
    record?: any;
    resource?: string;
    fields?: string[];
    separator?: string;
    fallback?: string;
    label?: string;
}

const HumanDeleteButton = ({
    record,
    resource,
    fields = ['name'],
    separator = ' — ',
    fallback = 'cet élément',
    label = '',
}: HumanDeleteButtonProps) => {
    if (!record) return null;

    const values = fields
        .map((field) => String(record[field] || '').trim())
        .filter(Boolean);

    const humanName = values.join(separator) || fallback;

    return (
        <DeleteButton
            record={record}
            resource={resource}
            undoable={false}
            label={label}
            title="Supprimer"
            confirmTitle={`Supprimer : ${humanName} ?`}
            confirmContent="Cet élément sera définitivement supprimé."
        />
    );
};

export default HumanDeleteButton;
